export type GoalType = 'habit' | 'todo';
export type Tint = 'moss' | 'brick' | 'plum' | 'gold' | 'ember';

export interface AuthUser {
  id: string;
  email: string;
}

export interface Goal {
  id: string;
  title: string;
  type: GoalType;
  cat: string;
  note: string;
  created_at: string;
  archived_at: string | null;
  completed_at: string | null;
  due_date: string | null;
}

export interface CheckIn {
  goal_id: string;
  day: string;
  created_at: string;
}

export interface CategoryMeta {
  key: string;
  label: string;
  tint: Tint;
  color: string;
  icon: string | null;
}

/**
 * A category row as stored in D1. Seeded with six defaults on signup
 * (migration 002 / `seedDefaultCategories`) — there is no distinction
 * between "built-in" and "user-made" rows any more.
 */
export interface Category {
  id: string;
  key: string;
  label: string;
  tint: Tint;
  icon: string | null;
  created_at: string;
}

export const TINT_COLORS: Record<Tint, string> = {
  moss:  '#5a6b2e',
  brick: '#b83a26',
  plum:  '#5a3242',
  gold:  '#e5a42b',
  ember: '#7a2a1f',
};

export const TINT_KEYS: Tint[] = ['moss', 'brick', 'plum', 'gold', 'ember'];

export const FALLBACK_CAT: CategoryMeta = {
  key: 'unknown',
  label: 'UNKNOWN',
  tint: 'brick',
  color: TINT_COLORS.brick,
  icon: null,
};

export interface NewGoalInput {
  title: string;
  type: GoalType;
  cat: string;
  note?: string;
  due_date?: string | null;
}

export interface UpdateGoalInput {
  title?: string;
  type?: GoalType;
  cat?: string;
  note?: string;
  archive?: boolean;
  completed?: boolean;
  due_date?: string | null;
}
